import api from './api';

export interface Customer {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  address?: string | null;
  city?: string | null;
  commune?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  country?: string | null;
  company_name?: string | null;
  company_type?: string | null;
  date_of_birth?: string | null;
  gender?: string | null;
  id_card_number?: string | null;
  id_card_type?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_phone?: string | null;
  emergency_contact_relation?: string | null;
  preferences?: any;
  notes?: string | null;
  // Champs ajoutés pour correspondre à la réponse API (root-level)
  email?: string;
  phone?: string;
  company?: string;
  status?: string;
  updated_at?: string;
  created_at?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  user?: {
    id: number;
    email: string;
    phone?: string;
    role: string;
    status: string;
  };
}

export interface CustomerFilters {
  search?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface CustomersResponse {
  success: boolean;
  data: {
    customers: Customer[];
    total: number;
    deleted_count?: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

class CustomersService {
  // Récupérer la liste des clients
  async getCustomers(filters: CustomerFilters = {}): Promise<CustomersResponse> {
    const response = await api.get<CustomersResponse>('/customers', { params: filters });
    return response.data;
  }

  // Récupérer un client par son ID
  async getCustomerById(id: number): Promise<Customer> {
    const response = await api.get<{ success: boolean; data: Customer }>(`/customers/${id}`);
    return response.data.data;
  }

  // Créer un nouveau client
  async createCustomer(customerData: Partial<Customer>): Promise<Customer> {
    const response = await api.post<{ success: boolean; data: Customer }>('/customers', customerData);
    return response.data.data;
  }

  // Mettre à jour un client
  async updateCustomer(id: number, customerData: Partial<Customer>): Promise<Customer> {
    const response = await api.put<{ success: boolean; data: Customer }>(`/customers/${id}`, customerData);
    return response.data.data;
  }

  // Supprimer un client
  async deleteCustomer(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  }

  // Purger tous les clients marqués comme supprimés
  async purgeDeletedCustomers(): Promise<{ 
    success: boolean; 
    message: string; 
    total: number;
    successCount: number;
    errorCount: number;
  }> {
    const response = await api.delete('/customers/purge-deleted');
    return response.data;
  }
}

export const customersService = new CustomersService();
